import { makeMutationHook, makeQueryHook } from "utils/apolloUtils";

import {
  GetEventTemplates,
  GetEventTemplatesVariables,
} from "./__generated__/GetEventTemplates";
import {
  GetEventTemplate,
  GetEventTemplateVariables,
} from "./__generated__/GetEventTemplate";
import { GET_EVENT_TEMPLATES, GET_EVENT_TEMPLATE } from "./queries";
import {
  CreateEventTemplate,
  CreateEventTemplateVariables,
} from "./__generated__/CreateEventTemplate";
import { CREATE_EVENT_TEMPLATE, UPDATE_EVENT_TEMPLATE } from "./mutations";
import {
  UpdateEventTemplate,
  UpdateEventTemplateVariables,
} from "./__generated__/UpdateEventTemplate";

export const useEventTemplateCreateMutation = makeMutationHook<
  CreateEventTemplate,
  CreateEventTemplateVariables
>(CREATE_EVENT_TEMPLATE);

export const useEventTemplateUpdateMutation = makeMutationHook<
  UpdateEventTemplate,
  UpdateEventTemplateVariables
>(UPDATE_EVENT_TEMPLATE);

export const useEventTemplateListQuery = makeQueryHook<
  GetEventTemplates,
  GetEventTemplatesVariables
>(GET_EVENT_TEMPLATES);

export const useEventTemplateDetailsQuery = makeQueryHook<
  GetEventTemplate,
  GetEventTemplateVariables
>(GET_EVENT_TEMPLATE);
